import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-header">
        <h1>Sobre a MercadoTV</h1>
        <p>Especialistas em Segurança Eletrónica há mais de 10 anos</p>
      </div>

      <div className="about-content">
        <div className="about-section">
          <h2>A Nossa Missão</h2>
          <p>
            A MercadoTV dedica-se a fornecer soluções completas de segurança eletrónica, 
            incluindo sistemas de videovigilância, alarmes e videoporteiros. A nossa missão 
            é proteger o que mais importa para si, oferecendo produtos de qualidade e 
            serviços profissionais.
          </p>
        </div>

        <div className="about-section">
          <h2>Os Nossos Valores</h2>
          <ul>
            <li><strong>Qualidade:</strong> Trabalhamos apenas com as melhores marcas do mercado</li>
            <li><strong>Transparência:</strong> Todos os custos são apresentados sem mensalidades</li>
            <li><strong>Profissionalismo:</strong> Equipa técnica especializada e certificada</li>
            <li><strong>Suporte:</strong> Acompanhamento completo desde a venda até a instalação</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>Localização</h2>
          <div className="location-info">
            <p><strong>Morada:</strong> Rua do Mercado nº298, Vale de Cambra, Portugal</p>
            <p><strong>Telefone:</strong> +351 256 418 202</p>
            <p><strong>Email:</strong> mlptelecomunicacoes@gmail.com</p>
            <p><strong>Horário:</strong> Segunda a Sexta: 9h-12h | 14h-19h | Sábado: 9h-12h30</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
